<template>
  <nav class="app-navbar" :class="{ guest: !isAuthenticated }">
    <div class="mobile-header">
      <router-link to="/" tag="div" class="app-navbar__logos">
        <img src="@/assets/img/logo.svg" alt="Logo Venda e Ganhe" />
        <img src="@/assets/img/logo_philco.svg" alt="Logo Philco" />
      </router-link>
      <button v-if="isAuthenticated" @click="toggleNav" v-app-button.icon-only>
        <b-icon icon="menu" />
      </button>
    </div>
    <div
      v-if="isAuthenticated"
      class="app-navbar__menus"
      v-bind:class="{ toggled: toggled }"
    >
      <ol>
        <li v-for="menu in menus" :key="menu.title">
          <router-link
            @click.native="toggleNav"
            tag="div"
            :to="menu.path ? menu.path : { name: menu.route }"
          >
            {{ menu.title }}
          </router-link>
          <ol v-if="menu.children" class="submenus">
            <router-link
              @click.native="toggleNav"
              tag="li"
              v-for="submenu in menu.children"
              :key="submenu.title"
              :to="{ name: submenu.route }"
              >{{ submenu.title }}</router-link
            >
          </ol>
        </li>
      </ol>
      <app-navbar-user class="user"></app-navbar-user>
    </div>
  </nav>
</template>

<script>
import AppNavbarUser from './AppNavbarUser.vue';
import MENUS from '@/constants/menus.constant';

export default {
  name: 'app-navbar',
  components: {
    AppNavbarUser,
  },
  data: () => {
    return {
      menus: MENUS,
      toggled: false,
    };
  },
  methods: {
    toggleNav() {
      this.toggled = !this.toggled;
    },
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/_navbar.scss';

.app-navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #fff;
  border-bottom: 1px solid #f4f5fa;
  box-shadow: 0px 2px 14px rgba(0, 0, 0, 0.1);
  height: var(--navbar-height);
  padding: 0.8em 2em;

  &.guest {
    justify-content: center;
  }

  .mobile-header {
    height: 100%;
    i {
      display: none;
    }
  }

  &__logos {
    display: flex;
    align-items: center;
    cursor: pointer;

    img:first-child {
      max-width: 160px;
      margin-right: 16px;
    }
  }

  &__menus {
    display: flex;
    align-items: center;

    > ol {
      list-style: none;
      display: flex;
      align-items: center;
      height: var(--navbar-height);

      > li {
        position: relative;
        height: 100%;

        div {
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          height: 100%;
          font-weight: 500;
          font-size: 0.75em;
          text-align: center;
          padding: 0 1em;
          cursor: pointer;

          @media (min-width: 1333px) {
            font-size: 0.9em;
          }

          &.router-link-exact-active {
            position: relative;

            &::after {
              content: '';
              background: var(--color-primary);
              height: 10px;
              width: 100%;
              position: absolute;
              left: 0;
              bottom: 0;
              border-radius: 10px 10px 0 0;
              animation: fadeIn 0.2s ease-in-out;
            }
          }
        }

        ol.submenus {
          position: absolute;
          list-style-type: none;
          top: 100%;
          left: 0;
          background: #fff;
          border-radius: 0 0 4px 4px;
          min-width: 220px;
          box-shadow: 0 8px 14px rgba(0, 0, 0, 0.1);
          display: none;
          cursor: pointer;
          > li {
            padding: 16px;
            font-weight: 500;
            text-transform: uppercase;

            &:hover {
              background: rgba(0, 0, 0, 0.04);
            }
          }
        }

        &:hover {
          > div {
            background: rgba(0, 0, 0, 0.04);
          }

          @media (min-width: 1024px) {
            ol.submenus {
              display: unset;
            }
          }

          &.router-link-exact-active {
            &::after {
              background: var(--color-primary-shade);
            }
          }
        }
      }
    }
  }
}

@media (max-width: 992px) {
  .app-navbar {
    position: initial;
    width: 100%;
    flex-direction: column;
    height: auto;

    overflow: visible;

    &__logos {
      /* height: var(--navbar-height); */
    }

    .mobile-header {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      i {
        display: unset;
        cursor: pointer;
      }
    }

    &__menus {
      margin-top: 2em;
      width: 100%;
      align-items: center;
      justify-content: center;

      background: #fff;
      z-index: 1;

      display: none;
      &.toggled {
        display: block;
      }

      > ol {
        display: block;
        width: 100%;
        height: auto;

        > li {
          div {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            min-height: var(--navbar-height);
            border-bottom: 1px solid var(--color-light-grey);
            font-size: 1em;

            &.router-link-exact-active::after {
              width: 50%;
              left: 25%;
            }

            &:not(:only-child) {
              box-shadow: 0 4px 4px rgba(0, 0, 0, 0.1);
            }
          }

          ol.submenus {
            position: static;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            box-shadow: none;
            background: rgba(0, 0, 0, 0.02);

            > li {
              padding: 16px;
              font-weight: 500;
              text-transform: uppercase;
              font-size: 1em;
              width: 100%;
              text-align: center;
              cursor: pointer;

              &:hover {
                background: rgba(0, 0, 0, 0.04);
              }
            }
          }
        }
      }
    }
  }
}
</style>
